import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapCustomerService {

  Receive_info: Subject<any> = new Subject();
  constructor() { }
  
  Show(data){
   this.Receive_info.next({  data:data});
  }
 
  close(data){
    this.Receive_info.next(data);
   }

}
